import React, { useEffect, useRef, useState } from 'react'
import { api } from '../utils'

import { UTENTE } from '../utils/endpoint'
import Icon from './atomic/Icon'
import SlickSlider from 'react-slick'
import SliderItem from './SliderItem'

const Slider = (props) => {
  const {
    items,
    titolo,
    hideNav,
    classes = '',
    type,
    inTab = false,
    progettiSpeciali = false,
    slidesToShow = 5,
  } = props

  let prev = useRef(null)
  let next = useRef(null)
  let slider = useRef(null)

  const [slides, setSlides] = useState([])

  const classDisabled = 'slider__nav-item--disabled'

  function checkTools() {
    const params = items.map(({ id, model }) => ({ content_type_id: model, object_id: id }))

    api.get(UTENTE + 'tools/', { params }).then((response) => {
      if (response && response.data && Array.isArray(response.data) && response.data.length > 0) {
        const enhancedSlides = items.map((item) => {
          const current = response.data.find(
            (e) => e.content_type_id === item.model && e.object_id === item.id
          )
          if (!current) return null
          const { saved, following, file_url, pdf_file } = current
          return (
            <SliderItem
              item={{ extra: { ...item.extra, file_url, pdf_file }, saved, following, ...item }}
              type={type || item.model_class}
              key={item.id}
            />
          )
        })
        setSlides(enhancedSlides.filter((item) => item !== null))
      }
    })
  }

  const loadSlides = () => {
    const slides = items.map((item, index) => (
      <SliderItem item={item} type={type || item.model_class} key={index} />
    ))

    setSlides(slides)

    if ((!inTab || progettiSpeciali) && classes !== 'moduli') checkTools()
  }

  useEffect(() => {
    loadSlides()
    if (!hideNav) {
      handleChange()
    }
  }, [items])

  const handleChange = (index = 0) => {
    if (!hideNav) {
      if (index === 0) {
        if (prev && next) {
          prev.classList.add(classDisabled)
          next.classList.remove(classDisabled)
        }
      } else if (
        slider &&
        slider.innerSlider &&
        index === slides.length - slider.innerSlider?.props?.slidesToShow
      ) {
        if (prev && next) {
          prev.classList.remove(classDisabled)
          next.classList.add(classDisabled)
        }
      } else {
        if (prev && next) {
          prev.classList.remove(classDisabled)
          next.classList.remove(classDisabled)
        }
      }
    }
  }

  const settings = {
    infinite: false,
    slidesToShow,
    slidesToScroll: 1,
    variableWidth: true,
    arrows: false,
    onSwipe: handleChange,
    afterChange: handleChange,
    responsive: [
      {
        breakpoint: 1820,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  }

  const handlePrev = () => {
    if (slider) {
      slider.slickPrev()
    }
  }

  const handleNext = () => {
    if (slider) {
      slider.slickNext()
    }
  }

  return (
    <div className={`${inTab ? 'in-tab' : 'section'} ${classes} slider__section`}>
      <div className="slider__header">
        {titolo ? <h2 className="slider__title">{titolo}</h2> : null}
        {hideNav ? null : (
          <div className="slider__nav">
            <button
              className={`slider__nav-item slider__nav-item--prev`}
              onClick={handlePrev}
              ref={(self) => (prev = self)}
            >
              <Icon id="chevron-sharp-right" />
            </button>
            <button
              className={`slider__nav-item slider__nav-item--next`}
              onClick={handleNext}
              ref={(self) => (next = self)}
            >
              <Icon id="chevron-sharp-right" />
            </button>
          </div>
        )}
      </div>
      <div className="slider">
        <div className="w-container-fluidright">
          <SlickSlider ref={(self) => (slider = self)} {...settings}>
            {slides}
          </SlickSlider>
        </div>
      </div>
    </div>
  )
}

export default Slider
